import React from 'react';
import './icon.scss';
import { IconProps } from '../../types/icons';

const LuggageIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className = '',
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className} `;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="luggage-icon"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.49992 2.83398V3.50065H8.49992V2.83398H7.49992ZM6.99992 1.33398C6.44763 1.33398 5.99992 1.7817 5.99992 2.33399V4.00065H5.33325C4.22868 4.00065 3.33325 4.89608 3.33325 6.00065V12.0007C3.33325 13.1052 4.22868 14.0007 5.33325 14.0007C5.33325 14.3688 5.63173 14.6673 5.99992 14.6673C6.36811 14.6673 6.66659 14.3688 6.66659 14.0007H9.33325C9.33325 14.3688 9.63173 14.6673 9.99992 14.6673C10.3681 14.6673 10.6666 14.3688 10.6666 14.0007C11.7712 14.0007 12.6666 13.1052 12.6666 12.0007V6.00065C12.6666 4.89608 11.7712 4.00065 10.6666 4.00065L9.99992 4.00065V2.33398C9.99992 1.7817 9.5522 1.33398 8.99992 1.33398H6.99992ZM10.6666 5.50065H5.33325C5.05711 5.50065 4.83325 5.72451 4.83325 6.00065V12.0007C4.83325 12.2768 5.05711 12.5007 5.33325 12.5007H10.6666C10.9427 12.5007 11.1666 12.2768 11.1666 12.0007V6.00065C11.1666 5.72451 10.9427 5.50065 10.6666 5.50065ZM7.99992 6.00065C7.72378 6.00065 7.49992 6.22451 7.49992 6.50065V11.5007C7.49992 11.7768 7.72378 12.0007 7.99992 12.0007C8.27606 12.0007 8.49992 11.7768 8.49992 11.5007V6.50065C8.49992 6.22451 8.27606 6.00065 7.99992 6.00065ZM5.33325 6.50065C5.33325 6.22451 5.55711 6.00065 5.83325 6.00065C6.10939 6.00065 6.33325 6.22451 6.33325 6.50065V11.5007C6.33325 11.7768 6.10939 12.0007 5.83325 12.0007C5.55711 12.0007 5.33325 11.7768 5.33325 11.5007V6.50065ZM10.1666 6.00065C9.89044 6.00065 9.66659 6.22451 9.66659 6.50065V11.5007C9.66659 11.7768 9.89044 12.0007 10.1666 12.0007C10.4427 12.0007 10.6666 11.7768 10.6666 11.5007V6.50065C10.6666 6.22451 10.4427 6.00065 10.1666 6.00065Z"
        fill={fill || '#7E8A96'}
      />
    </svg>
  );
};

export default LuggageIcon;
